import { Container, Row, Col } from "react-bootstrap";
import ShopAdds from "../shopAds/ShopAdds";
import {
  Businessprofiletitle,
  Connectivity,
  Timeline,
} from "../../pages/index";
import "./businessprofile.css";

const Businessprofile = () => {
  return (
    <>
      <Container>
        <Row className="business-profile-layout">
          <Col lg="7" className="screenHeight p-0 business-profile-column">
            <div className="border b-radius business-profile-panel">
              <ShopAdds />
              <Businessprofiletitle />
              <Connectivity profileLayout />
            </div>
          </Col>
          
          <Col
            lg="5"
            sm="12"
            className="ps-4 screenHeight business-profile-column"
            style={{ position: "relative" }}
          >
            <div className="border b-radius business-profile-panel">
              <Timeline />
            </div>
          </Col>

        </Row>
      </Container>
    </>
  );
};

export default Businessprofile;
